import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
  },
  reducers: {
    login: (state, action) => {
      const user = action.payload;

      // if (user.account_type === "cluster_manager" && user.gyms) {
      //   const savedGymId = localStorage.getItem("selectedGym");
      //   const defaultGymId = user.gyms?.gyms[0]?.value;

      //   user.gym_id = savedGymId ? savedGymId : defaultGymId;
      // }

      state.isAuthenticated = true;
      state.user = user;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
    // setGymId: (state, action) => {
    //   if (state.user?.account_type === "cluster_manager") {
    //     state.user.gym_id = action.payload;
    //   }
    // },
  },
});

export const {
  login,
  logout,
  // ,setGymId
} = authSlice.actions;
export default authSlice.reducer;
